import { firebase } from '../firebase/firebase';

export const login = (userUid) => ({
  type: 'LOGIN',
  userUid
});

export const logout = () => ({
  type: 'LOGOUT'
});

export const sendPasswordResetEmail = (email) => {
  return () => {
    return firebase.auth().sendPasswordResetEmail(email).then(() => {
      alert('Correo enviado');
    }).catch((error) => {
      alert(error.message);
    });
  };
};

export const startLogin = (email, password) => {
  return () => {
    return firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
      return user.uid;
    }).catch((error) => {
     alert(error.message);
    });
  };
};

export const startLogout = () => {
  return firebase.auth().signOut();
};
